<template>
  <div class="record-container">
    <div class="head">
      <h3 class="title">积分记录</h3>
    </div>
    <div class="records">
      <scroll-view
        class="records-scroll"
        :reach-bottom-loading="loading"
        :finish="finish"
        @loadData="handleLoad"
      >
        <div v-for="(record, index) in records" :key="index" class="record">
          <h3 class="title">
            {{ record.title }}
          </h3>
          <p class="date">
            {{ record.createTime }}
          </p>
          <span class="code" :class="{ increase: record.score >= 0 }">
            {{ record.score >= 0 ? `+${record.score}` : `${record.score}` }}
          </span>
        </div>
      </scroll-view>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { API } from '@/api'
import ScrollView from '@/common/widgets/scroll_view'
export default {
  components: {
    ScrollView
  },
  data() {
    return {
      loading: false,
      finish: false,
      records: []
    }
  },
  computed: {
    ...mapState('integral', {
      produceScoreMonth: state => state.produceScoreMonth,
      consumeScoreMonth: state => state.consumeScoreMonth
    })
  },
  mounted() {
    this.page = 1
    this.getScoreRecord(this.page)
  },
  methods: {
    async getScoreRecord(page) {
      this.loading = true
      try {
        const res = await API.memberIntegral.getScoreRecord({
          pageSize: 10,
          pageNum: page
        })
        this.loading = false
        this.records = this.records.concat(res.list)
        this.finish = res.isLastPage
      } catch (e) {
        this.loading = false
        this.$catch(e)
      }
    },
    handleLoad() {
      this.page = this.page + 1
      this.getScoreRecord(this.page)
    }
  }
}
</script>
<style lang="scss" scoped>
.record-container {
  position: relative;
  flex: 1;
  box-sizing: border-box;
  padding: 0.3rem 0.3rem 0;
  background: #f2f2f2;
  & > .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.4rem;
    & > .title {
      font-size: 0.36rem;
      color: #333;
    }

    & > .info {
      color: #333;
      font-size: 0.24rem;

      & > .colorful {
        color: #ff6f14;
      }
    }
  }
  & > .records {
    display: flex;
    position: absolute;
    top: 1rem;
    bottom: 0;
    left: 0.3rem;
    right: 0.3rem;
    background: #fff;
    border-radius: 0.1rem 0 0 0.1rem;
    overflow: hidden;
    & .record {
      display: flex;
      flex-direction: column;
      position: relative;
      justify-content: center;
      box-sizing: border-box;
      padding: 0.34rem 0;
      margin: 0 0.34rem;
      height: 1.5rem;
      border-bottom: 0.5px solid #ececec;

      & > .title {
        text-align: left;
        color: #333;
        font-size: 0.28rem;
      }

      & > .date {
        text-align: left;
        color: #999;
        margin-top: 0.1rem;
        font-size: 0.24rem;
      }

      & > .code {
        position: absolute;
        font-size: 0.28rem;
        margin: auto;
        right: 0.24rem;
        color: #0daf52;

        &.increase {
          color: #ff6f14;
        }
      }
    }
  }
}
</style>
